/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("click", (e) => {
  if (e.target.closest(".stockist-result-custom-fields a")) {
    e.preventDefault();

    var el = e.target;
    var url = new URL(el.getAttribute("href"));

    console.log(url);

    var shop = url.searchParams.get("shop");
    var email = url.searchParams.get("email");

    var modal = document.querySelector("#modal-store-locator");
    var form = modal.querySelector(".g-container");
    var message = modal.querySelector(".message");

    var shop_name = modal.querySelector("#hidden");
    var shop_email = modal.querySelector("#hidden-2");

    shop_name.value = shop;
    shop_email.value = email;

    form.style.display = "block";
    message.style.display = "none";
    modal.setAttribute("open", "true");
  }

  // DIGITAL-6299: track Stockist installer phone clicks (do not preventDefault)
  var phoneLink = e.target.closest('#stockist-widget a[href^="tel:"], #stockist-widget a[href^="TEL:"]');
  if (phoneLink) {
    trackInstallerPhoneClick(phoneLink);
  }
});

/**
 * Fire-and-forget phone click log → Google Apps Script → Sheet.
 * Also pushes installer_phone_click to dataLayer for optional GTM/GA4.
 */
function trackInstallerPhoneClick(phoneLink) {
  try {
    var href = phoneLink.getAttribute('href') || '';
    var phoneDisplay = (phoneLink.textContent || '').trim() || href.replace(/^tel:/i, '').trim();
    var phoneNormalized = phoneDisplay.replace(/\D/g, '');
    if (!phoneNormalized) {
      phoneNormalized = href.replace(/^tel:/i, '').replace(/\D/g, '');
    }

    var result =
      phoneLink.closest('.stockist-list-result, .stockist-map-result, .stockist-result') ||
      phoneLink.closest('[class*="stockist-"]');
    var nameEl = result && result.querySelector('.stockist-result-name');
    var installerName = nameEl ? nameEl.textContent.trim() : 'Unknown';

    var source = 'list';
    if (phoneLink.closest('.stockist-map-result, .stockist-map-inner, .stockist-map')) {
      source = 'map';
    }

    var brisbaneParts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Australia/Brisbane',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(new Date());
    var getPart = function (type) {
      var part = brisbaneParts.find(function (p) {
        return p.type === type;
      });
      return part ? part.value : '';
    };
    var date = getPart('year') + '-' + getPart('month') + '-' + getPart('day');
    var timestamp =
      date +
      'T' +
      getPart('hour') +
      ':' +
      getPart('minute') +
      ':' +
      getPart('second') +
      '+10:00';

    var payload = {
      timestamp: timestamp,
      date: date,
      installer_name: installerName,
      phone_normalized: phoneNormalized,
      phone_display: phoneDisplay,
      page_path: window.location.pathname || '',
      source: source
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'installer_phone_click',
      installer_name: installerName,
      phone_normalized: phoneNormalized,
      phone_display: phoneDisplay,
      page_path: payload.page_path,
      source: source
    });

    var endpoint =
      (window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.installerPhoneTrackingEndpoint) ||
      '';
    if (!endpoint) return;

    // text/plain avoids CORS preflight; Apps Script reads postData.contents.
    // Do not use mode:'no-cors' — Apps Script redirects and needs a normal POST follow.
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      keepalive: true,
      redirect: 'follow'
    }).catch(function () {
      /* never block dialing */
    });
  } catch (err) {
    /* never block dialing */
  }
}

// forces page to scroll to anchor
if (location.hash) {
  const anchor = location.hash.replace("#", "");
  const element = document.getElementById(anchor);
  element.scrollIntoView();
}

class QuotaCalculator extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('.qc-form-input-number')
    this.meterage_x_chargeout_elem = this.querySelector('#qc_meterage_x_chargeout_total_value')
    this.numhrs_x_chargeout_elem = this.querySelector('#qc_chargeout_x_numhrs_value')
    this.total_elem = this.querySelector('#qc_form_total_value')
    this.loadEvents()
  }
  loadEvents() {
    this.inputs.forEach(input => {
      input.addEventListener('input', this.handleInput.bind(this))
    })
  }
  handleInput() {
    this.objectValues = this.constructObject()

    console.log(this.objectValues)

    this.total_film_charge = this.objectValues.film_meterage * this.objectValues.film_charge_out
    this.total_labor_charge = this.objectValues.labor_chargeout * this.objectValues.num_hrs
    this.total = this.total_labor_charge + this.total_film_charge
    this.renderTotals()
  }
  constructObject() {
    const obj = this.objectValues || {};
    this.inputs.forEach(input => {
      obj[input.name] = input.value
    })
    return obj;
  }
  renderTotals() {
    const total_film_charge = this.total_film_charge || 0
    const total_labor_charge = this.total_labor_charge || 0
    const total = this.total || 0

    this.meterage_x_chargeout_elem.textContent = Shopify.tbFormatMoney((total_film_charge * 100), themeVariables.settings.moneyFormat)
    this.numhrs_x_chargeout_elem.textContent = Shopify.tbFormatMoney((total_labor_charge * 100), themeVariables.settings.moneyFormat)
    this.total_elem.textContent = Shopify.tbFormatMoney((total * 100), themeVariables.settings.moneyFormat)

  }
}

customElements.define('quota-calculator', QuotaCalculator)

document.addEventListener('variant:changed', function (event) {
  // Get the selected variant ID from the event
  const variantId = event.detail.variant.id;

  const sticky_form_id_input = document.querySelector('.product-form__sticky form[action="/cart/add"] input[name="id"]');

  if (!sticky_form_id_input) return;

  sticky_form_id_input.value = variantId;

})



document.addEventListener('DOMContentLoaded', () => {

  // new Swiper('.shopify-section--options .image-list', {
  //   breakpoints: {
  //     0: {
  //       slidesPerView: 1.2
  //     },
  //     424: {
  //       slidesPerView: 1.5
  //     },
  //     767: {
  //       slidesPerView: 1.8
  //     },
  //     900: {
  //       slidesPerView: 2
  //     },
  //     1024: {
  //       slidesPerView: 2.4
  //     },
  //     1280: {
  //       slidesPerView: 3
  //     }
  //   },
  //   spaceBetween: 28
  // });

  const shopMenuItem = document.querySelector('.mega-menu-text-image')?.closest('.header__linklist-item');
  let clickedShopMenuItem = false;
  if (shopMenuItem) {
    shopMenuItem.addEventListener('click', (e) => {
      shopMenuItem.classList.toggle('active');
      clickedShopMenuItem = true;
    });
    
    document.addEventListener('click', (e) => {
      if(e.target.closest('.mega-menu-text-image') || e.target.classList.contains('mega-menu-text-image')) {
        clickedShopMenuItem = false;
        shopMenuItem.classList.toggle('active');
        return;
      }
      if (!shopMenuItem.classList.contains('active') && e.target.closest('.header__linklist-item') == shopMenuItem) {
        shopMenuItem.classList.add('active');
      } else {
        if (clickedShopMenuItem) {
          clickedShopMenuItem = false;
          return;
        }
        shopMenuItem.classList.remove('active');
      }
    });
  }


  new Swiper('.shopify-section--category .category-list',{
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2
      },
      512: {
        slidesPerView: 1.8
      },
      700: {
        slidesPerView: 2.4
      },
      900: {
        slidesPerView: 3
      },
      1000: {
        slidesPerView: 3.6
      },
      1200: {
        slidesPerView: 4.2
      },
      1280: {
        slidesPerView: 5
      }
    }
  });
});


(function () {
  const html = document.documentElement;
  let lastScroll = window.pageYOffset;
  let ticking = false;

  const getEls = () => ({
    brands: document.querySelector(".shopify-section--custom-brands"),
    announce: document.querySelector(
      ".shopify-section--announcement-bar, .shopify-section--custom-messaging"
    ),
    header: document.querySelector(
      ".shopify-section--header, .shopify-section--header-vael"
    )
  });

  const update = () => {
    const { brands, announce, header } = getEls();
    if (!brands && !announce && !header) return;

    const brandsH = brands ? brands.offsetHeight : 0;
    const announceH = announce ? announce.offsetHeight : 0;
    const totalH = brandsH + announceH;

    // enforce positioning
    [brands, announce, header].forEach(el => {
      if (el) {
        el.style.position = "sticky";
        el.style.left = "0";
        el.style.right = "0";
      }
    });

    const current = window.scrollY;

    if (current < lastScroll) {
      // SCROLL UP → show all
      if (brands) brands.style.top = "0px";
      if (announce) announce.style.top = `${brandsH}px`;
      if (header) header.style.top = `${totalH}px`;
      html.style.setProperty("--header-offset", `${totalH}px`);
    } else {
      // SCROLL DOWN → hide brands + announce
      if (brands) brands.style.top = `-${brandsH}px`;
      if (announce) announce.style.top = `-${announceH}px`;
      if (header) header.style.top = "0px";
      html.style.setProperty("--header-offset", "0px");
    }

    lastScroll = current;
    ticking = false;
  };

  const scheduleUpdate = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener("scroll", scheduleUpdate, { passive: true });

  // Shopify late-load safety
  const observed = new Set();
  const resizeObserver =
    "ResizeObserver" in window ? new ResizeObserver(scheduleUpdate) : null;

  const observeSections = () => {
    Object.values(getEls()).forEach(el => {
      if (el && !observed.has(el)) {
        observed.add(el);
        if (resizeObserver) resizeObserver.observe(el);
      }
    });
    scheduleUpdate();
  };

  observeSections();
  document.addEventListener("DOMContentLoaded", observeSections);
  window.addEventListener("load", observeSections);
  document.addEventListener("shopify:section:load", observeSections);
  if (!resizeObserver) window.addEventListener("resize", scheduleUpdate);
})();



// ==========================
// Drawer Quick Add Button JS
// ==========================

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.ymal-add-to-cart');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  if (window.__addingToCart) return;
  window.__addingToCart = true;

  try {
    const form = btn.closest('form');
    if (!form) return;

    // ✅ Activate Focal's built-in loader
    btn.setAttribute('loading', 'true');
    btn.disabled = true;

    // Build FormData manually to include quantity
    const formData = new FormData(form);
    const qtyInput = form.closest('.product-form').querySelector('input[name="quantity"]');
    if (qtyInput) {
      formData.set('quantity', qtyInput.value || 1);
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    setTimeout(() => {
      btn.removeAttribute('loading');
      btn.disabled = false;
    }, 1000);

  } catch (err) {
    console.error('Error adding product:', err);
    btn.removeAttribute('loading');
    btn.disabled = false;
  } finally {
    setTimeout(() => {
      window.__addingToCart = false;
    }, 500);
  }
});